import DbConfig from '../../../config/DbConfig.js'
import {rtrim,getCurrentTime} from '../../functions/Common.js'

// 保存数据
export function save(data,callback){
	if(data === undefined || data.id === undefined || data.group_id === undefined){
		callback(false)
		return
	}
	let id = data.id
	let group_id = data.group_id
	let fans_id = data.fans_id
	let custom_id = data.custom_id
	let client_type = data.client_type
	let chatting_id = data.chatting_id
	
	let db = DbConfig.connect()
	let sql = 'insert into yswl_friend_group_rel(id,client_type,custom_id,fans_id,chatting_id,group_id) values(?,?,?,?,?,?) '
	db.transaction(tx=>{
		tx.executeSql(sql,[id,client_type,custom_id,fans_id,chatting_id,group_id],(tx,results)=>{ 
			callback({
				id,client_type,custom_id,fans_id,chatting_id,group_id
			})
		},(tx,error)=>{
			console.log(error)
			callback(false)
		})
	})

}


// 根据聊天id,获取此聊天的所有已选的组
export function getByChattingId(id,callback){
	if(id === undefined){
		callback(false)
		return
	}
	
	let db = DbConfig.connect()
	let sql = 'select * from yswl_friend_group_rel where chatting_id = ? and client_type = 1'
	db.transaction(tx=>{
		tx.executeSql(sql,[id],(tx,results)=>{ 
			let list = []
			for(let i = 0;i < results.rows.length;i++){
				list.push(results.rows[i])
			}
			callback(list)
		},(tx,error)=>{
			console.log(error)
			callback(false)
		})
	})

}


// 根据id, 删除
export function deleteById(id,callback){
	let db = DbConfig.connect()
	db.transaction(tx=>{
		tx.executeSql('delete from yswl_friend_group_rel where id = ?',[id],(tx,results)=>{ 
			callback(true)
		},(error,tx)=>{
			callback(false)
		})
	})
}


// 删除所有的数据
export function deleteAll(callback){
	let db = DbConfig.connect()
	db.transaction(tx=>{
		tx.executeSql('delete from yswl_friend_group_rel where id > 0',[],(tx,results)=>{ 
			callback(true)
		},(error,tx)=>{
			callback(false)
		})
	})
}